import api from './api'

//成员详情接口
export const addMessageToBoard = async data => {
    return await api.post('/cms/messageBoard/submit', data);
}